import React from 'react';
import { Button } from 'react-bootstrap';
import styles from '../styles/ErrorScreen.module.scss';
import { ReactComponent as PropdocsLogo } from '../../../shared/icons/propdocs-logo.svg';

interface ErrorScreenProps {
  error: string;
  onRetry?: () => void;
  onClose: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ error, onRetry, onClose }) => {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.backgroundBlur}></div>
      <div className={styles.errorContainer}>
        <div className={styles.errorCard}>
          <div className={styles.header}>
            <div className={styles.logoContainer}>
              <PropdocsLogo className={styles.logo} />
            </div>
            <h1 className={styles.title}>Oops, this link isn't valid</h1>
          </div>

          <div className={styles.errorContent}>
            <p className={styles.errorMessage}>{error}</p>

            <div className={styles.suggestions}>
              <p className={styles.suggestionsTitle}>This could happen if:</p>
              <ul className={styles.suggestionsList}>
                <li>The signing session has expired</li>
                <li>The document has already been signed</li>
                <li>The signing process was cancelled</li>
                <li>You don't have permission to sign</li>
              </ul>
            </div>
          </div>

          <div className={styles.actions}>
            {onRetry && (
              <Button variant="secondary" onClick={onRetry} className={styles.retryBtn}>
                Try Again
              </Button>
            )}
            <Button variant="primary" onClick={onClose} className={styles.closeBtn}>
              Close
            </Button>
          </div>

          <div className={styles.helpSection}>
            <p>
              If you continue to experience issues, please{' '}
              <a href="mailto:support@propdocs.com">
                contact support
              </a>
              .
            </p>
          </div>

          <div className={styles.footer}>
            <p className={styles.poweredBy}>Powered by Propdocs • Secured with Digital Certificates</p>
          </div>
        </div>
      </div>
    </div>
  );
};
